import { getCssVar, setCssVar } from '../../scripts/utils/css'

export const selector = '#global-header'

export default (el) => {
    if (!el)
        return

    console.groupCollapsed('GlobalHeader')

    console.log(el)

    const setHeightVar = () => {
        const height = `${el.clientHeight}px`

        if (getCssVar('--global-header-height') !== height)
            setCssVar('--global-header-height', height)
    }

    setHeightVar()

    let resizeDebounce

    const onResize = (e) => {
        setHeightVar()

        if (resizeDebounce)
            clearTimeout(resizeDebounce)

        resizeDebounce = setTimeout(setHeightVar, 200)
    }

    window.removeEventListener('resize', onResize)

    window.addEventListener('resize', onResize)

    console.groupEnd()

    return el
}
